import i18n from "../i18n";

const DAY_KEYS = [1, 2, 3, 4, 5, 6, 7];

// Chapter names — surfaced as a small gold kicker above "DAY X" and later
// used as chapter headings in the printed book / PDF.
export const STORY_WEEK_CHAPTERS = {
  1: "The Soundtrack",
  2: "Home",
  3: "Fully Alive",
  4: "The Ones Who Believed",
  5: "The Hard Chapter",
  6: "The Turning Point",
  7: "What to Remember",
};

function t(key, opts) { return i18n.t(key, opts); }

export function getStoryWeekDays() {
  return DAY_KEYS.map((day) => ({
    day,
    chapter: STORY_WEEK_CHAPTERS[day],
    title: t(`storyWeek.day${day}.title`),
    opening: t(`storyWeek.day${day}.opening`),
    question: t(`storyWeek.day${day}.question`),
    ifItHelps: [1, 2, 3, 4, 5, 6, 7]
      .map((i) => t(`storyWeek.day${day}.help${i}`))
      .filter((s) => s && !s.startsWith("storyWeek.")),
    quiet: t(`storyWeek.day${day}.quiet`),
  }));
}

// Backwards-compat: reactive Proxy so existing `STORY_WEEK_DAYS.find(...)` calls
// pick up whichever language is currently active.
export const STORY_WEEK_DAYS = new Proxy([], {
  get(_target, prop) {
    const arr = getStoryWeekDays();
    if (prop === "length") return arr.length;
    if (prop === Symbol.iterator) return arr[Symbol.iterator].bind(arr);
    const idx = typeof prop === "string" ? Number(prop) : NaN;
    if (!Number.isNaN(idx)) return arr[idx];
    const v = arr[prop];
    return typeof v === "function" ? v.bind(arr) : v;
  },
});

export function getStoryWeekWelcome() {
  return {
    title: t("storyWeek.welcome.title"),
    subtitle: t("storyWeek.welcome.subtitle"),
    body: t("storyWeek.welcome.body"),
    cta: t("storyWeek.welcome.cta"),
  };
}

export function getStoryWeekEnd() {
  return {
    header: t("storyWeek.end.header"),
    body: t("storyWeek.end.body"),
    cta: t("storyWeek.end.cta"),
    quiet: t("storyWeek.end.quiet"),
  };
}

// Reactive proxies so existing imports keep working (JSX reads them at render).
export const STORY_WEEK_WELCOME = new Proxy({}, {
  get(_t, prop) { return getStoryWeekWelcome()[prop]; },
});

export const STORY_WEEK_END = new Proxy({}, {
  get(_t, prop) { return getStoryWeekEnd()[prop]; },
});

export const STORY_WEEK_HASHTAGS = ["#StoryWeek", "#TheLivingBook", "#StoryKeeper"];
